import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { PastDispatchesComponent } from './components/past-dispatches/past-dispatches.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { RoutesName } from './shared/constants/routes-name';
import { performanceAdminRedirectGuard } from './shared/guards/performance-admin-redirect.guard';
import { performanceAdminGuard } from './shared/guards/performance-admin.guard';
import { selectedEventGuard } from './shared/guards/selected-event.guard';

const portfolioSiteChildren = [
  {
    path: `${RoutesName.PORTFOLIO}/:productId`,
    component: PastDispatchesComponent,
    canActivate: [selectedEventGuard],
    data: { breadcrumb: 'PD.ROUTES.DISPATCH_PORTFOLIO' },
    children: [
      {
        path: `${RoutesName.SITE}/:siteId`,
        component: PastDispatchesComponent,
        data: { breadcrumb: 'PD.ROUTES.DISPATCH_SITE' },
      },
    ],
  },
];

const orgChildren = [
  {
    path: RoutesName.EVENT_DETAILS,
    component: PastDispatchesComponent,
    canActivate: [selectedEventGuard],
    data: { breadcrumb: 'PD.ROUTES.PERFORMANCE_DETAILS' },
  },
];

export const routes: Routes = [
  {
    path: RoutesName.ROOT,
    component: HomeComponent,
    title: 'Past Dispatches',
    data: { breadcrumb: 'PD.ROUTES.DISPATCH' },
    children: [
      {
        path: RoutesName.ROOT,
        component: PastDispatchesComponent,
        data: { breadcrumb: 'PD.ROUTES.PAST_DISPATCHES' },
        children: [
          {
            path: RoutesName.ROOT,
            canActivate: [performanceAdminRedirectGuard],
            component: PastDispatchesComponent,
            pathMatch: 'full',
          },
          {
            path: RoutesName.PROGRAM,
            canActivate: [performanceAdminGuard],
            component: PastDispatchesComponent,
            children: portfolioSiteChildren,
          },
          {
            path: RoutesName.ORGANIZATION,
            component: PastDispatchesComponent,
            children: orgChildren,
          },
        ],
      },
      // Uncomment if Analytics is needed
      // {
      //   path: RoutesName.ANALYTICS,
      //   component: AnalyticsComponent,
      //   title: 'Analytics',
      //   data: { breadcrumb: 'Analytics' },
      // },
    ],
  },
  {
    path: RoutesName.UNAUTHORIZED,
    component: UnauthorizedComponent,
  },
];
